import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import AutoplayVideos from './components/AutoplayVideos';
import './components/HashFix';
import BarbaApp from './barba/BarbaApp';
import Menu from './components/Menu';

class Santeon {
	constructor() {
		// Promises waarop gewacht  wordt. Standaard wordt er gewacht op het 'DOMContentLoaded' event
		Promise.all([Santeon.domReady()]).then(() => this.init());
	}

	init() {
		new Menu();
		new AutoplayVideos();
		new BarbaApp();
	}

	static domReady() {
		return new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve));
	}
}

new Santeon();
